import { gql } from 'graphql-request';

export const putTelephoneNumberQuery = gql`
  mutation putTelephoneNumber($billingCustomerId: String!, $assignedProductId: String!) {
    putTelephoneNumber(billingCustomerId: $billingCustomerId, assignedProductId: $assignedProductId) {
      changePhoneNumberOrderId
    }
  }
`;
